<button
  type="button"
  class="multiple-select"
  [class.error]="this.showError"
  [attr.aria-label]="this.triggerAriaLabel"
  #trigger
  (click)="showSelectControl(trigger)"
  [disabled]="!this.items.length"
>
  <span class="content"
    ><span class="label"
      ><span class="placeholder">{{ fieldName }}</span
      >{{ this.checkedItemsLabel }}</span
    >
    @if (!this.allUnChecked && !this.allChecked) {
      <span class="counter">({{ this.checkedItems.length }})</span>
    }
  </span>
  @if (this.controlOverlay == null) {
    <mat-icon class="expand-icon">expand_more</mat-icon>
  }
  @if (this.controlOverlay != null) {
    <mat-icon class="expand-icon">expand_less</mat-icon>
  }
</button>
